<template>
    <div id="gallery-scrollable-container" class="renderfix" style="flex-grow: 1; flex-shrink: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; scroll-behavior: smooth;">
        <div style="background: #F8F8F8; padding: 0 0 20px 0; position: relative;"></div>
        <error-boundary v-for="(g, i) in galleryCategories" :key="g.id">
                <pm-gallery-group class="renderfix" v-once :grid="grid" :settings="g"  :class="i < 6 ? 'pm-animation-fade-in-slide-down' : ''" :style="'--delay: '+i * 100+'ms'" />
        </error-boundary>
    </div>
</template>

<style>

.pm-fadein-transition-leave-active {
    transition: opacity .6s, transform .3s;
    transform: translateY(0px);
}

.pm-fadein-transition-enter-active {
    transition: opacity .6s, transform .3s;
}

.pm-fadein-transition-enter-to {
    opacity: 1;
    transform: translateY(0px);
}

.pm-fadein-transition-enter, .pm-fadein-transition-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}
</style>

<script>
import galleryCategories from "../../configs/gallery/categories.json";
import PmGalleryGroup from "./group";
export default {
    components: {
        PmGalleryGroup,
    },
    props: {
        grid: {
            type: Number,
        }
    },
    data: () => ({
        galleryCategories: galleryCategories,
    }),
}
</script>
